var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isDesktopClient
    ? _c("DesktopClient")
    : _c(
        "div",
        { staticClass: "tai-xiu-feature" },
        [
          _vm.activeProduct === "cockfight"
            ? _c("CockFight", { staticClass: "cockfight-background" })
            : _c("LayoutMainPage", { staticClass: "full-tai-xiu" }, [
                _c(
                  "main",
                  {
                    ref: "txContent",
                    staticClass: "full-tai-xiu__content",
                    class: {
                      "full-tai-xiu__content--sticky-video": _vm.isVideoSticky,
                    },
                  },
                  [
                    _vm.activeTable
                      ? _c(
                          "TaiXiuBoardLayout",
                          {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "top",
                                  fn: function () {
                                    return [
                                      _c("TaiXiuFullBoardTop", {
                                        attrs: {
                                          table: _vm.activeTable,
                                          "last-result": _vm.lastResult,
                                          "is-rolling": _vm.isRolling,
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              3228919865
                            ),
                          },
                          [
                            _c(
                              "BetBoard",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "full-tai-xiu__board",
                                    attrs: { full: "" },
                                  },
                                  "BetBoard",
                                  _vm.fullBoardProps(_vm.activeTable),
                                  false
                                ),
                                _vm.fullBoardListeners
                              )
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
          _c(
            "Transition",
            { attrs: { name: "bar-slide" } },
            [
              _vm.showTableBar
                ? _c("TableBar", {
                    staticClass: "feature-table-bar",
                    attrs: {
                      tables: _vm.tables,
                      "active-product": _vm.activeProduct,
                      "active-table-id": _vm.activeTable
                        ? _vm.activeTable.id
                        : "",
                      "quick-bet-table-id": _vm.quickBetTable
                        ? _vm.quickBetTable.id
                        : "",
                      "quick-play-enabled": _vm.quickPlayEnabled,
                    },
                    on: {
                      close: _vm.onTableBarClose,
                      "quick-play": _vm.setQuickPlay,
                      "select-table": _vm.selectTable,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "Transition",
            { attrs: { name: "quick-fade" } },
            [
              _vm.quickBetTable
                ? _c(
                    "QuickPlaySheet",
                    _vm._g(
                      _vm._b(
                        { on: { close: _vm.closeQuickBet } },
                        "QuickPlaySheet",
                        _vm.boardProps(_vm.quickBetTable),
                        false
                      ),
                      _vm.boardListeners
                    )
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.activeProduct === "tai-xiu"
            ? _c("MenuPopup", { attrs: { fixed: "" } })
            : _vm._e(),
          _vm.activeProduct === "tai-xiu" ? _c("BetErrorPopup") : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }